/**
 * Color tokens for the Untool Mage application
 * Defines brand colors (blue, green) and semantic colors
 */

// Brand Colors - Blue (Primary)
export const blue = {
  main: '#0071FF',
  light: '#338DFF',
  dark: '#0056CC',
  contrastText: '#FFFFFF',
} as const

// Brand Colors - Green (Secondary)
export const green = {
  main: '#22C55E',
  light: '#4ade80',
  dark: '#16a34a',
  contrastText: '#FFFFFF',
} as const

// Semantic Colors
export const semantic = {
  success: {
    main: '#22C55E',
    light: '#4ade80',
    dark: '#16a34a',
  },
  error: {
    main: '#DC2626',
    light: '#FEF6F6',
    dark: '#4A1515',
  },
  warning: {
    main: '#EE8437',
    light: '#FEFAF7',
    dark: '#3D2410',
  },
  info: {
    main: '#0071FF',
    light: '#F5F9FF',
    dark: '#0A1929',
  },
} as const

// Neutral Colors
export const neutral = {
  50: '#F1F5F9',
  100: '#E2E8F0',
  200: '#CBD5E1',
  300: '#94A3B8',
  400: '#64748B',
  500: '#475569',
  600: '#334155',
  700: '#1E293B',
  800: '#0F172A',
  900: '#1D1F21',
} as const

// Light Mode Colors
export const lightMode = {
  background: {
    default: '#FAFAFA',
    paper: '#FFFFFF',
    // Modal surface. Matches paper in light mode; recedes well below it in dark
    // mode so a dialog reads as lifted off the page rather than blending in.
    dialog: '#FFFFFF',
  },
  text: {
    primary: '#111827',
    secondary: '#4B5563',
  },
  divider: '#E5E7EB',
} as const

// Dark Mode Colors
export const darkMode = {
  background: {
    default: '#303643',
    paper: '#3A4258',
    dialog: '#050608',
  },
  text: {
    primary: '#E8EAED',
    secondary: '#BCC3D0',
  },
  divider: '#4A5061',
} as const

// Kenneth mascot colors
export const kenneth = {
  light: {
    lines: '#0071FF',
    accent: '#FFD952',
    body: '#FFFFFF',
  },
  dark: {
    lines: '#0071FF',
    accent: '#FFE566',
    body: '#FFFFFF',
  },
} as const


export type TColorToken = typeof blue | typeof green | typeof semantic
